module.exports = __webpack_public_path__ + "img/connectdevelop.4ae83537.svg";